import { ErrorRecoveryActions } from "./error-recovery-actions";

export const Forbidden = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center pb-40">
      <p className="text-9xl font-bold text-tw-gray-200">403</p>
      <h1 className="mt-6 text-xl font-bold text-tw-gray-400">
        この画面を開く権限がありません
      </h1>
      <p className="mt-3">
        必要な場合は、テナントの管理者にロールの変更を依頼してください。
      </p>

      <ErrorRecoveryActions className="mt-12" />
    </div>
  );
};
